import type { InvoiceDetail } from '../useQueryInvoiceDetail/types';
import type { RemoveDlnItemLinkVariables } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import { zodInvoiceDetailSchema } from '../useQueryInvoiceDetail/validations';

/**
 * Removes one manual delivery note article link from a line item.
 *
 * @param variables - Invoice, line item and the link to remove.
 * @returns The updated invoice detail.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/unlink_dln_item_invoices__invoice_id__line_items__line_item_id__dln_item_links__link_id__delete
 */
export async function removeDlnItemLink({
  invoiceId,
  lineItemId,
  linkId,
}: RemoveDlnItemLinkVariables): Promise<InvoiceDetail> {
  return vestigasApi
    .delete(
      ENDPOINT.INVOICE.REMOVE_DLN_ITEM_LINK(invoiceId, lineItemId, linkId),
      {
        validate: {
          isResponseSensitive: true,
          response: zodInvoiceDetailSchema,
        },
      },
    )
    .json<InvoiceDetail>();
}
